import Newsletter_35Container from "./container/Newsletter_35Container";
export default Newsletter_35Container;
